import { EmployeeProfileCorporateTrainingsSectionTranslation } from '@/assets/locales/views/employeeProfile/sections/corporateTrainings/employeeProfile.corporateTrainings.translation.pl.ts';

export const employeeProfileCorporateTrainingsSectionTranslation: EmployeeProfileCorporateTrainingsSectionTranslation =
  {
    content: {
      competencyArea: 'Competency Area',
      form: {
        corporateTrainingsType: 'Trainings',
        subtitle:
          'Select recommended training areas for the employee (for Learning and Development Department)',
        title: 'Training Needs',
      },
      noTrainings: 'No Selected Trainings',
      noTrainingsSelected: 'Choose Training Areas',
      selected: 'Selected',
      skills: 'Skills',
    },
    headerTitle: 'Training Needs Assessment',
    headerTitleShorter: 'Training Needs Assessment',
  };
